<div class="card border-light-subtle shadow-sm p-3">
  <div class="d-flex flex-column gap-3">
    <div class="d-flex justify-content-between">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3044_977"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="30"
          height="31"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.2439 18.0754C15.7484 18.7188 15.2559 19.2752 14.7693 19.7415C14.2828 20.2077 13.8081 20.5714 13.3423 20.8356C12.8794 21.0998 12.4403 21.2304 12.0309 21.2304C11.8618 21.2304 11.7045 21.1993 11.5592 21.134C11.4138 21.0718 11.2862 20.9848 11.1764 20.8729C11.0667 20.761 10.9836 20.6305 10.9213 20.4781C10.862 20.3258 10.8293 20.1611 10.8293 19.9839V15.368L6.14166 20.8574C6.02002 20.9848 5.88948 21.0781 5.74707 21.1371C5.60466 21.1962 5.45928 21.2273 5.30797 21.2273C5.14479 21.2273 4.99052 21.1962 4.84811 21.1309C4.7057 21.0687 4.58109 20.9817 4.47131 20.8698C4.36154 20.7579 4.2755 20.6274 4.2132 20.475C4.15089 20.3227 4.11826 20.158 4.11826 19.9808V1.41751H6.47988V16.804L11.1853 11.296C11.3544 11.1188 11.5562 11.0069 11.7906 10.9571C12.025 10.9105 12.2534 10.9354 12.4759 11.038C12.7162 11.1405 12.9032 11.3053 13.0367 11.5353C13.1524 11.7373 13.2028 11.9767 13.2028 12.216V18.0505C13.7101 17.5376 14.17 16.9936 14.5824 16.4248C14.9948 15.8529 15.3775 15.2654 15.7306 14.6592C16.0836 14.0531 16.4189 13.4376 16.7304 12.8128C16.8102 12.655 16.8883 12.4954 16.966 12.3367L16.966 12.3366L17.0449 12.1756C17.4187 11.4172 18.1634 10.9416 18.9763 10.9416H19.4926C19.5875 10.9323 19.6824 10.9261 19.7715 10.9261H24.0319C24.4383 10.9261 24.8003 10.9789 25.1207 11.0877C25.4411 11.1965 25.726 11.3395 25.9692 11.5167C26.2155 11.6938 26.4232 11.899 26.5953 12.1352C26.7673 12.3715 26.9097 12.617 27.0166 12.8719C27.1263 13.1299 27.2064 13.3879 27.2569 13.6459C27.3073 13.907 27.334 14.1526 27.334 14.3888V17.7365C27.334 18.1624 27.2836 18.5447 27.1797 18.8835C27.0759 19.2223 26.9394 19.5208 26.7703 19.7787C26.6012 20.0367 26.4054 20.2543 26.1799 20.4346C25.9544 20.6149 25.72 20.7641 25.4767 20.876C25.2305 20.991 24.9842 21.0749 24.738 21.1278C24.4888 21.1806 24.2544 21.2086 24.0289 21.2086H20.709C20.1898 21.2086 19.7715 20.7672 19.7715 20.2264V19.7197C19.7715 19.1757 20.1928 18.7374 20.709 18.7374H24.0289C24.3434 18.7374 24.5808 18.6504 24.738 18.4794C24.8952 18.3085 24.9753 18.0598 24.9753 17.7365V14.4075C24.9753 14.0655 24.8952 13.8106 24.735 13.6459C24.5748 13.4812 24.3404 13.3972 24.0319 13.3972H19.7893C19.4688 13.3972 19.2256 13.4812 19.0624 13.649C18.8992 13.8169 18.8161 14.0624 18.8161 14.3857V30.2261H16.4575V17.7894L16.4574 17.7895C16.3862 17.8858 16.315 17.9822 16.2439 18.0754ZM16.4575 30.2261V31.2911H1.08202V5.14758C0.81448 0.828148 1.14646 0.866459 2.90155 1.069C3.24916 1.10911 3.6526 1.15567 4.11826 1.17609V1.41751H1.37391V30.2261H16.4575ZM18.8161 30.2261V30.7027H26.5211C31.3274 30.7027 31.6193 30.7027 30.3732 26.4898V1.09799H30.0843H6.47988V1.41751H30.0843V30.2261H18.8161Z"
            fill="#191C1E"
          />
        </mask>
        <g mask="url(#mask0_3044_977)">
          <rect x="2" y="2" width="27" height="28" fill="#1567EE" />
        </g>
      </svg>
      <p
        style="font-size: 12px"
        class="bg-primary-subtle m-0 px-2 py-1 rounded fw-bold border"
      >
        Best Seller
      </p>
    </div>

    <h2>Wealth Planning - Advisor 360°</h2>
  </div>

  <div>
    <p class="m-0 fw-medium">Inclui:</p>
    <div class="d-flex justify-content-between mt-2">
      <span>Projeto de Consultoria</span>
      <strong>{{ financialConsultantValueBr }}</strong>
    </div>
    <div class="d-flex justify-content-between mt-2">
      <span class="text-primary">+ Serviço de Acompanhamento</span>
      <strong class="text-primary">{{ followUpServiceValueBr }}</strong>
    </div>
    <div class="d-flex justify-content-between mt-4 pt-2 border-top">
      <span>Total</span>
      <strong>{{ advisorValueBr }}</strong>
    </div>
  </div>

  <div class="d-flex flex-column gap-3 mt-5">
    <div
      style="min-height: 138px; cursor: pointer"
      class="card p-3 border-light-subtle shadow-sm"
      [ngClass]="isCreditCardSelected ? 'option-selected' : 'card-money'"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex gap-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934C21.7794 4.65804 21.3978 4.5 21 4.5ZM21 6V8.25H3V6H21ZM21 18H3V9.75H21V18ZM19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5H15.75C15.5511 16.5 15.3603 16.421 15.2197 16.2803C15.079 16.1397 15 15.9489 15 15.75C15 15.5511 15.079 15.3603 15.2197 15.2197C15.3603 15.079 15.5511 15 15.75 15H18.75C18.9489 15 19.1397 15.079 19.2803 15.2197C19.421 15.3603 19.5 15.5511 19.5 15.75ZM13.5 15.75C13.5 15.9489 13.421 16.1397 13.2803 16.2803C13.1397 16.421 12.9489 16.5 12.75 16.5H11.25C11.0511 16.5 10.8603 16.421 10.7197 16.2803C10.579 16.1397 10.5 15.9489 10.5 15.75C10.5 15.5511 10.579 15.3603 10.7197 15.2197C10.8603 15.079 11.0511 15 11.25 15H12.75C12.9489 15 13.1397 15.079 13.2803 15.2197C13.421 15.3603 13.5 15.5511 13.5 15.75Z"
              fill="#00658F"
            />
          </svg>

          <h4 class="fw-medium">Cartão de Crédito</h4>
        </div>
        <input
          [(ngModel)]="isCreditCardSelected"
          (change)="creditCardSelected()"
          style="width: 20px"
          type="checkbox"
          name=""
          id="creditCardSelected"
        />
      </div>

      <div>
        <span class="fs-5">
          Até {{ this.dataStoreSetting.installments }}x de
          <span class="fs-3 fw-medium">{{
            advisorInstallmentValueBr
          }}</span></span
        >
      </div>
    </div>

    <div
      style="min-height: 138px; cursor: pointer"
      class="card p-3 border-light-subtle shadow-sm"
      [ngClass]="isInCashSelected ? 'option-selected' : 'card-money'"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex gap-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 8.25C11.2583 8.25 10.5333 8.46993 9.91661 8.88199C9.29993 9.29404 8.81928 9.87971 8.53545 10.5649C8.25162 11.2502 8.17736 12.0042 8.32205 12.7316C8.46675 13.459 8.8239 14.1272 9.34835 14.6517C9.8728 15.1761 10.541 15.5333 11.2684 15.6779C11.9958 15.8226 12.7498 15.7484 13.4351 15.4645C14.1203 15.1807 14.706 14.7001 15.118 14.0834C15.5301 13.4667 15.75 12.7417 15.75 12C15.75 11.0054 15.3549 10.0516 14.6517 9.34835C13.9484 8.64509 12.9946 8.25 12 8.25ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25ZM22.5 5.25H1.5C1.30109 5.25 1.11032 5.32902 0.96967 5.46967C0.829018 5.61032 0.75 5.80109 0.75 6V18C0.75 18.1989 0.829018 18.3897 0.96967 18.5303C1.11032 18.671 1.30109 18.75 1.5 18.75H22.5C22.6989 18.75 22.8897 18.671 23.0303 18.5303C23.171 18.3897 23.25 18.1989 23.25 18V6C23.25 5.80109 23.171 5.61032 23.0303 5.46967C22.8897 5.32902 22.6989 5.25 22.5 5.25ZM18.1547 17.25H5.84531C5.5935 16.3984 5.13263 15.6233 4.50467 14.9953C3.87671 14.3674 3.10162 13.9065 2.25 13.6547V10.3453C3.10162 10.0935 3.87671 9.63263 4.50467 9.00467C5.13263 8.37671 5.5935 7.60162 5.84531 6.75H18.1547C18.4065 7.60162 18.8674 8.37671 19.4953 9.00467C20.1233 9.63263 20.8984 10.0935 21.75 10.3453V13.6547C20.8984 13.9065 20.1233 14.3674 19.4953 14.9953C18.8674 15.6233 18.4065 16.3984 18.1547 17.25ZM21.75 8.75344C20.8504 8.36662 20.1334 7.64959 19.7466 6.75H21.75V8.75344ZM4.25344 6.75C3.86662 7.64959 3.14959 8.36662 2.25 8.75344V6.75H4.25344ZM2.25 15.2466C3.14959 15.6334 3.86662 16.3504 4.25344 17.25H2.25V15.2466ZM19.7466 17.25C20.1334 16.3504 20.8504 15.6334 21.75 15.2466V17.25H19.7466Z"
              fill="#00658F"
            />
          </svg>
          <h4 class="fw-medium">À vista (PIX ou boleto)</h4>
        </div>
        <input
          [(ngModel)]="isInCashSelected"
          (change)="inCashSelected()"
          style="width: 20px"
          type="checkbox"
          name=""
          id=""
        />
      </div>
      <div>
        <span
          class="fs-6 fw-medium text-dark-emphasis text-decoration-line-through"
        >
          {{ advisorValueBr }}</span
        >
      </div>
      <div class="d-flex align-content-center align-items-center gap-2 mt-2">
        <span class="fs-3 fw-medium">{{ advisorValueWithDiscountBr }}</span>
        <p style="font-size: 12px" class="m-0 border px-2 py-1 rounded fw-bold">
          Economize {{ dataStoreSetting.percentualDiscount }}%
        </p>
      </div>
    </div>
  </div>
</div>
